/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionOverwolfVerification
 */
export interface CompetitionOverwolfVerification {
    /**
     * 
     * @type {boolean}
     * @memberof CompetitionOverwolfVerification
     */
    verified: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompetitionOverwolfVerification
     */
    gameSessionId?: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionOverwolfVerification
     */
    verifiedAt?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompetitionOverwolfVerification
     */
    discrepancies?: Array<string>;
}

/**
 * Check if a given object implements the CompetitionOverwolfVerification interface.
 */
export function instanceOfCompetitionOverwolfVerification(value: object): value is CompetitionOverwolfVerification {
    if (!('verified' in value) || value['verified'] === undefined) return false;
    return true;
}

export function CompetitionOverwolfVerificationFromJSON(json: any): CompetitionOverwolfVerification {
    return CompetitionOverwolfVerificationFromJSONTyped(json, false);
}

export function CompetitionOverwolfVerificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionOverwolfVerification {
    if (json == null) {
        return json;
    }
    return {
        
        'verified': json['verified'],
        'gameSessionId': json['gameSessionId'] == null ? undefined : json['gameSessionId'],
        'verifiedAt': json['verifiedAt'] == null ? undefined : json['verifiedAt'],
        'discrepancies': json['discrepancies'] == null ? undefined : json['discrepancies'],
    };
}

export function CompetitionOverwolfVerificationToJSON(json: any): CompetitionOverwolfVerification {
    return CompetitionOverwolfVerificationToJSONTyped(json, false);
}

export function CompetitionOverwolfVerificationToJSONTyped(value?: CompetitionOverwolfVerification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'verified': value['verified'],
        'gameSessionId': value['gameSessionId'],
        'verifiedAt': value['verifiedAt'],
        'discrepancies': value['discrepancies'],
    };
}

